<template>
  <div class="registerform__step step__one">
    <div class="step__content">
      <div class="step__headline">
        <h4 class="-color-alpha">Wählen Sie eine der folgenden Möglichkeiten:</h4>
      </div>
      <div class="step__form">
        <div class="form__entry">
          <div class="entry-wrapper" @click="setDecision(1)">
            <div class="entry__headline icon-angle-right-after">
              <h5>Ich möchte mich unverbindlich informieren</h5>
            </div>
          </div>
          <div class="entry-wrapper" @click="setDecision(2)">
            <div class="entry__headline icon-angle-right-after">
              <h5>Ich möchte eine persönliche Vorstellung der Vermietsoftware</h5>
            </div>
          </div>
          <div class="entry-wrapper" @click="setDecision(3)">
            <div class="entry__headline icon-angle-right-after">
              <h5>KT Vermietsoftware 14 Tage kostenlos testen</h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StepOne',
  methods: {
    setDecision: function (decision) {
      this.$emit('setDecision', decision)
      this.$emit('updateStep', 'StepTwo')
    }
  }
}
</script>
